import { useCallback } from "react";

import Badge from "ds/components/Badge";
import TooltipInfo from "ds/components/TooltipInfo";

type YankedBadgeProps = {
  notes?: string | null;
};

const YankedBadge = ({ notes }: YankedBadgeProps) => {
  const MemoizedTooltip = useCallback(
    () => <TooltipInfo>{notes}</TooltipInfo>,
    [notes]
  );

  return (
    <Badge variant="red" type="strong" text="BAD" endIcon={notes ? MemoizedTooltip : undefined} />
  );
};

export default YankedBadge;
